import { createSlice } from "@reduxjs/toolkit";
import { routerChangeAction, Routes } from "const";
import cloneDeep from 'lodash/cloneDeep'
import moment from "moment-timezone";

const initialState = {
  submitting: false,
  page: 1,
  direction: 0,
  sendingOTP: false,
  initializing: false,
  redeemAccount: null,
  riskUserProfileLevel: null,
  exchangeRateFlag: null,
}

const handlePageChange = (state, targetPage) => {
  state.direction = targetPage - state.page
  state.page = targetPage
}

const slice = createSlice({
  initialState,
  name: "buy",
  extraReducers: (builder) => {
    builder.addCase(routerChangeAction, (state, { payload }) => {
      if (payload.location.pathname === Routes.UltraHigh.BuySellSwitching.Buy) {
        return cloneDeep(initialState)
      }
    })
  },
  reducers: {
    initialBuyFund: state => cloneDeep(initialState),
    inquirySuitabilitySuccess: (state, { payload }) => {
      state.riskUserProfileLevel = payload.riskUserProfileLevel
      state.exchangeRateFlag = payload.exchangeRateFlag
    },
    inquirySuitabilityFailure: (state, { payload }) => {
      state.riskUserProfileLevel = null
    },
    getRedeemAccount: state => {
      state.initializing = true
      state.redeemAccount = null
    },
    getRedeemAccountSuccess: (state, action) => {
      state.initializing = false
      state.redeemAccount = action.payload.redeemAccount
    },
    getRedeemAccountFailure: (state, action) => {
      state.initializing = false
    },
    gotoFundPage: state => handlePageChange(state, 1),
    gotoConfirmPage: state => handlePageChange(state, 2),
    gotoOtpPage: state => handlePageChange(state, 3),
    gotoTransactionSuccessPage: state => handlePageChange(state, 4),
    goBack: state => {
      if (state.page !== 1) {
        state.page--
        state.direction = -1
      }
    },
    sendOTP: (state, action) => {
      state.sendingOTP = true
      state.otp = null
    },
    sendOTPSuccess: (state, action) => {
      state.sendingOTP = false
      state.otp = action.payload
    },
    sendOTPFailure: state => {
      state.sendingOTP = false
    },
    submit: state => {
      state.submitting = true
    },
    submitSuccess: (state, action) => {
      state.submitting = false
      state.resultTransaction = action.payload
      handlePageChange(state, 4)
    },
    submitFailure: state => {
      state.submitting = false
    },
    setCutOffInfo: (state, { payload }) => {
      const info = { ...payload }
      const $paymentStart = moment(info.paymentStart, 'HH:mm:ss'),
        $effectiveDate = moment(info.effectiveDate, 'YYYYMMDD'),
        $current = moment(info.transactionDate),
        currentDateStr = $current.format('YYYYMMDD');

      const sendTransToDay = currentDateStr === info.effectiveDate
      if (sendTransToDay) {
        const beforePaymentStart = $current.isBefore($paymentStart)
        info.messageId = beforePaymentStart ? "pwm.bss.confirm.buy.type-1" : "pwm.bss.confirm.buy.type-2"
      } else {
        info.messageId = "pwm.bss.confirm.buy.type-3"
      }

      // for display purpose
      info.paymentStartDisplay = $paymentStart.format('HH:mm')
      info.effectiveDateDisplay = $effectiveDate.format('DD/MM/YY')
      state.cutOffInfo = info
    },
  },
})

export const {
  initialBuyFund,
  getRedeemAccount,
  getRedeemAccountSuccess,
  getRedeemAccountFailure,
  gotoFundPage,
  gotoConfirmPage,
  gotoOtpPage,
  gotoTransactionSuccessPage,
  goBack,
  sendOTP,
  sendOTPSuccess,
  sendOTPFailure,
  submit,
  submitSuccess,
  submitFailure,
  inquirySuitabilitySuccess,
  inquirySuitabilityFailure,
  setCutOffInfo,
} = slice.actions;

export default slice.reducer;


